export default __webpack_public_path__ + "static/media/lb.675dd9cb.svg";